








































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IUser, EUserStatus, EUserGroup } from "@/components/shared/types";
import { User } from "@/components/User";
import { isObject } from "@/common/utils";
import { ICodeList } from "@/components/map/types";
import { IIconTool } from "@/components/shared/types";
import { SDS } from "@/components/SDS";

const TODAY = new Date();
const STATION_CHARTS_DATETIME_MENU:IIconTool[] = [{
    name: 'today',
    subTitle: TODAY,
    subTitleIsDate: true
  },{
    divider: true
  },{
    name: 'yesterday'
  },{
    name: 'lastNDays',
    nameReplacer: [3]
  },{
    name: 'lastNDays',
    nameReplacer: [7]
  },{
    name: 'lastNDays',
    nameReplacer: [30]
  },{
    name: 'lastNMonths',
    nameReplacer: [3]
  },/*{
    name: 'lastNMonths',
    nameReplacer: [12]
  },*/{
    name: 'lastNYears',
    nameReplacer: [1,'']
  }]

@Component({
  watch: {
    data(value) {
      this.setChartData();
    }
  }
})
export default class StationCharts extends Vue {
  @Prop({
    default: null
  }) data: Object;

  menuStationChartsTimeRange:IIconTool[] = STATION_CHARTS_DATETIME_MENU;

  titleReplacer = null;
  subTitle = null;
  subTitleReplacer = null;

  sds:SDS = new SDS();

  setChartData() {
    if (this.data && isObject(this.data)) {
      for (let p in this.data) {
        this[p] = this.data[p];
      }
    }
  }

  created() {
    this.setChartData();
  }

  toggleGistdaStationLayer(station:"Agritronics" | "AgritronicsPhase2" | "WaterStation") {
    this.$emit('changeMe',{
      menu: {
        name: 'toggle_station'
      },
      data: station
    });
  }

  showStationCharts(menu) {
    this.$emit('changeMe',{
      menu: {
        name: 'station_charts',
      },
      data: menu
    });
  }

  showStationOverview() {
    this.$emit('changeMe', {
      menu: {
        name: 'station_summary',
      },
      data: this.sds  //IMPORTANT
    });
  }

  closeMe() {
    this.$emit('closeRightToc');
  }
}
